export default __webpack_public_path__ + "static/media/The Training Room Online.d42e264e.png";